
import React from "react";
import HintPopover from "../../../gd-ui/hint-popover/hint-popover";

type Props = {
    className?   : string
    message?   : string
}

export default function FieldHelp(props:Props) {

    return (
        <div className={Classes("ui5-field-help", props.className)}>
            ?
            <HintPopover hint={props.message} multiline={true} />
        </div>
    )

}